export default {"src":"/_next/static/media/metlife.415cf0a1.svg","height":35,"width":161,"blurWidth":0,"blurHeight":0};